import { BoxV2 as Box, Flex, RoleGuard } from 'portal-commons';
import { FunctionComponent, useRef } from 'react';
import { faHourglass, faSpinner } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { BrandAsset, BrandAssetStatus } from '../../types';
import MoreButton from '../../../../../shared_elements/components/MoreButton';

interface BrandAssetRowProps {
  asset: BrandAsset;
  group: string;
  loading?: boolean;
  onSelect?: () => void;
  onVerify?: () => void;
}

const BrandAssetRow: FunctionComponent<BrandAssetRowProps> = ({
  asset,
  group,
  loading = false,
  onSelect,
  onVerify,
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleNameClick = () => {
    inputRef.current?.click();
  };

  return (
    <Box
      sx={{
        display: 'contents',
        '> *': {
          alignItems: 'center',
          paddingLeft: '16px',
        },
      }}
      data-testid="assetRow"
    >
      <Flex
        sx={{
          columnGap: '7px',
          color: '#0091B3',
          fontSize: '14px',
          lineHeight: '16px',
        }}
        data-testid="assetRow_Name"
      >
        <input
          ref={inputRef}
          style={{ accentColor: '#D41C62', cursor: 'pointer' }}
          type="radio"
          name={group}
          onClick={onSelect}
          data-testid="assetRadioButton"
        />
        <Box sx={{ cursor: 'pointer' }} onClick={handleNameClick}>
          {asset.name}
        </Box>
        {loading && (
          <FontAwesomeIcon icon={faSpinner} style={{ color: '#68737A' }} spin />
        )}
      </Flex>
      <Flex sx={{ columnGap: '7px' }} data-testid="assetRow_Status">
        {asset.verificationStatus?.toLowerCase() === 'pending' && (
          <FontAwesomeIcon icon={faHourglass} size="sm" />
        )}
        {asset.verificationStatus ?? 'N/A'}
      </Flex>
      <RoleGuard feature="brandDetail.verifyAsset">
        <Flex data-testid="assetRow_Actions">
          <MoreButton<BrandAsset>
            data={asset}
            menuClass="tcr-menu"
            data-testid="assetMoreButton"
            items={[
              {
                label: 'Verify',
                onClick: () => onVerify?.(),
                disabled:
                  !!asset.verificationStatus &&
                  asset.verificationStatus !== BrandAssetStatus.Expired,
              },
            ]}
          />
        </Flex>
      </RoleGuard>
    </Box>
  );
};

export default BrandAssetRow;
